<template>
  <div style="width: auto">
    <template-list
      :auto-load-list="true"
      :model="$orderReviewTag"
      :show-create-button="false"
      :key="templateListKey"
    >
      <template v-slot:actions>
        <v-btn
          class="rounded-lg"
          color="primary"
          depressed
          height="40"
          @click="openModal()"
        >
          <div class="text-none body-2 px-2">Создать</div>
        </v-btn>
      </template>
      <template v-slot:subactions>
        <v-col class="pa-0">
          <Tabs />

          <!-- Фильтры -->
          <v-row
            no-gutters
            class="mt-3 px-2"
            align="center"
          >
            <v-col
              cols="3"
              class="pr-3"
            >
              <v-select
                v-model="$orderReviewTag.filters.rating"
                :items="ratingOptions"
                item-text="label"
                item-value="value"
                outlined
                dense
                label="Фильтр по рейтингу"
                chips
                small-chips
                clearable
                hide-details
                @change="loadList"
              />
            </v-col>

            <v-col
              cols="3"
              class="pr-3"
            >
              <v-select
                v-model="$orderReviewTag.filters.pickup_type"
                :items="$order.pickupTypes"
                item-text="label"
                item-value="value"
                outlined
                dense
                label="Фильтр по типу заказа"
                chips
                small-chips
                clearable
                hide-details
                @change="loadList"
              />
            </v-col>
            <v-col
              cols="auto"
              class="pr-3"
            >
              <v-checkbox
                v-model="$orderReviewTag.filters.active"
                @change="loadList"
                :label="$orderReviewTag.filters.active ? 'Активные' : 'Архивные'"
                hide-details
                class="mt-0"
              />
            </v-col>
            <v-col
              cols="auto"
              class="pr-3"
            >
              <v-checkbox
                v-model="$orderReviewTag.filters.service"
                @change="loadList"
                label="Сервисные"
                hide-details
                class="mt-0"
              />
            </v-col>
          </v-row>
        </v-col>
      </template>
      <template v-slot="{ object, index }">
        <v-col
          class="pa-0 link"
          @click="openModal(object)"
        >
          <v-row no-gutters>
            <div
              class="ml-2"
              style="
                width: 22px;
                height: 22px;
                border: 1px solid #dedede;
                cursor: pointer;
                border-radius: 4px;
              "
              :style="{ background: object.color || '#fab400' }"
            ></div>
            <div class="ml-2 font-weight-medium text-truncate">
              {{ object.title }}
            </div>
            <div
              v-if="object.service"
              class="text-body-2 ml-2"
            >
              <v-chip
                x-small
                color="orange"
                outlined
                >Сервисный</v-chip
              >
            </div>
            <v-icon
              v-if="!object.active"
              color="error"
              size="18"
              class="ml-2"
            >
              mdi-eye-off
            </v-icon>
            <v-col
              cols="12"
              class="pa-0 ml-2"
            >
              <div class="text-body-2">Группа: {{ object.group?.title || 'Не выбрано' }}</div>
              <div class="text-body-2">Сортировка: {{ object.sorting || 0 }}</div>

              <!-- Отображение рейтингов -->
              <div
                v-if="object.ratings && object.ratings.length"
                class="text-body-2"
              >
                <span class="mr-2">Рейтинги:</span>
                <span
                  v-for="n in 5"
                  :key="n"
                >
                  <v-icon
                    :color="object.ratings.includes(n) ? '#FFD700' : '#E0E0E0'"
                    size="18"
                  >
                    mdi-star
                  </v-icon>
                </span>
              </div>

              <!-- Отображение типов заказов -->
              <div
                v-if="object.pickup_types && object.pickup_types.length"
                class="text-body-2"
              >
                <span class="mr-2">Типы заказов:</span>
                <v-chip
                  v-for="pickupType in object.pickup_types"
                  :key="pickupType"
                  x-small
                  class="mr-1"
                  color="primary"
                  outlined
                >
                  {{ getPickupTypeName(pickupType) }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </template>
    </template-list>
    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card
        v-if="dialogItem"
        class="pa-5 rounded-lg"
        style="overflow-x: auto"
      >
        <div class="font-weight-bold mb-5">
          {{ dialogItem.id ? 'Обновление категории' : 'Создание категории' }}
        </div>
        <v-row class="ma-0">
          <v-text-field
            outlined
            dense
            hide-details
            v-model="dialogItem.title"
            label="Текст"
          />
          <v-menu
            bottom
            offset-y
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <div
                style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #dedede;
                  cursor: pointer;
                  border-radius: 4px;
                "
                :style="{ background: dialogItem.color || '#fab400' }"
                v-on="on"
                class="ml-2"
              ></div>
            </template>
            <v-color-picker
              dot-size="13"
              hide-inputs
              hide-mode-switch
              mode="hexa"
              swatches-max-height="200"
              :value="dialogItem.color"
              @input="setColor($event, dialogItem)"
            ></v-color-picker>
          </v-menu>
        </v-row>

        <LazySelect
          :model="$orderReviewTagGroup"
          :item-text="v => v.title"
          item-value="id"
          outlined
          :multiple="false"
          dense
          v-model="dialogItem.group"
          label="Группа"
          set-to="list"
          :search-enabled="false"
          :preload="true"
          class="mt-3"
        />

        <v-select
          v-model="dialogItem.ratings"
          :items="ratingOptions"
          item-text="label"
          item-value="value"
          hide-details
          outlined
          dense
          multiple
          label="Рейтинги (1-5)"
          class="mt-3"
          chips
          small-chips
        />

        <v-select
          v-model="dialogItem.pickup_types"
          :items="$order.pickupTypes"
          item-text="label"
          item-value="value"
          outlined
          dense
          multiple
          hide-details
          label="Типы заказов"
          class="mt-3"
          chips
          small-chips
        />
        <v-text-field
          outlined
          dense
          v-model.number="dialogItem.sorting"
          label="Сортировка"
          type="number"
          class="mt-3"
          hide-details
        />

        <v-row class="ma-0 mt-2">
          <v-col
            cols="6"
            class="pa-0"
          >
            <v-checkbox
              v-model="dialogItem.active"
              dense
              label="Активность"
              hide-details
            />
          </v-col>
          <v-col
            cols="6"
            class="pa-0 pl-3"
          >
          </v-col>
        </v-row>

        <v-row class="ma-0 mt-2">
          <v-col
            cols="12"
            class="pa-0"
          >
            <v-checkbox
              v-model="dialogItem.service"
              dense
              label="Сервисный тег"
              hide-details
            />
          </v-col>
        </v-row>

        <v-row class="px-2 mt-4">
          <v-btn
            :disabled="!dialogItem.title"
            :loading="loading"
            color="primary"
            @click="saveDialogItem()"
            >Сохранить
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="dialogItem.id"
            :loading="loading"
            color="error"
            outlined
            @click="deleteDialogItem()"
            >Удалить
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Tabs from '@/admin/views/orderReviewTags/Tabs.vue'
  import LazySelect from '@/components/helpers/LazySelect.vue'

  export default {
    name: 'Reasons',
    components: { LazySelect, Tabs },
    data: () => ({
      dialog: false,
      dialogItem: null,
      loading: false,
      templateListKey: 0,
      showActive: true,
      ratingOptions: [
        { label: '1 звезда', value: 1 },
        { label: '2 звезды', value: 2 },
        { label: '3 звезды', value: 3 },
        { label: '4 звезды', value: 4 },
        { label: '5 звезд', value: 5 }
      ]
    }),
    methods: {
      setColor(e, item) {
        item.color = typeof e === 'object' ? e.hexa : e
      },
      openModal(_item) {
        let item = cloneDeep(_item)
        if (!item) item = cloneDeep(this.$orderReviewTag.default)
        this.dialogItem = item
        this.dialog = true
      },
      getPickupTypeName(pickupType) {
        const type = this.$order.pickupTypes.find(t => t.value === pickupType)
        return type ? type.label : pickupType
      },
      loadList() {
        this.$orderReviewTag.loadList()
      },
      saveDialogItem() {
        const create = !this.dialogItem.id
        const item = this.dialogItem
        this.loading = true
        if (create) {
          this.$orderReviewTag
            .create(item)
            .then(v => {
              this.$orderReviewTag.list.push(v)
              this.dialog = false
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$orderReviewTag
            .update(item)
            .then(v => {
              this.dialog = false
              const index = this.$orderReviewTag.list.findIndex(el => el.id === v.id)
              if (index > -1) this.$orderReviewTag.list[index] = v
              this.templateListKey++
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      deleteDialogItem() {
        this.loading = true
        this.$orderReviewTag
          .delete(this.dialogItem.id)
          .then(() => {
            this.dialog = false
            const index = this.$orderReviewTag.list.findIndex(v => v.id === this.dialogItem.id)
            if (index > -1) this.$orderReviewTag.list.splice(index, 1)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    watch: {
      dialog() {
        if (!this.dialog) this.dialogItem = null
      }
    },
    mounted() {
      // Устанавливаем начальное значение фильтра активности
      this.$orderReviewTag.filters.active = true
    }
  }
</script>

<style scoped></style>
